import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { sanityClient } from "../lib/sanityClient";

function CarImportationPage() {
  const [consultations, setConsultations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConsultations = async () => {
      try {
        const query = `*[_type == "importConsultation"]{
          _id, title, description, processSteps, fees
        }`;
        const fetchedConsultations = await sanityClient.fetch(query);
        setConsultations(fetchedConsultations);
      } catch (error) {
        console.error("Error fetching import consultations:", error);
      }
      setLoading(false);
    };

    fetchConsultations();
  }, []);

  return (
    <div className="container mx-auto px-4 py-8">
      <Helmet>
        <title>Car Importation Consultation | 237Mechanic</title>
        <meta
          name="description"
          content="Get expert guidance on importing vehicles. Learn about the process, fees, and required documentation with our consultation services."
        />
      </Helmet>

      <h1 className="text-3xl font-bold text-center mb-6">
        Car Importation Consultation
      </h1>
      <p className="text-lg text-gray-600 text-center mb-8">
        Need help importing a vehicle into Cameroon? Our consultation service provides 
        step-by-step guidance, cost breakdowns, and legal requirements 
        to make the process smooth and hassle-free.
      </p>

      {loading ? (
        <p className="text-center text-gray-500">Loading consultation services...</p>
      ) : consultations.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {consultations.map((consultation) => (
            <div key={consultation._id} className="border rounded-lg p-4 shadow-lg">
              <h2 className="text-xl font-semibold">{consultation.title}</h2>
              <p className="text-gray-600 mt-2">{consultation.description}</p>
              <h3 className="font-semibold mt-4">Process Steps:</h3>
              <ul className="list-disc list-inside text-gray-700">
                {consultation.processSteps?.map((step, index) => (
                  <li key={index}>{step}</li>
                ))}
              </ul>
              <p className="text-blue-600 font-medium mt-4">
                Consultation Fees: CFA {consultation.fees.toLocaleString()}
              </p>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-center text-gray-500">
          No consultation services available at the moment.
        </p>
      )}
    </div>
  );
}

export default CarImportationPage;
